import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { Navbar } from "@/components/common/Navbar";
import { Footer } from "@/components/common/Footer";
import { PLANS as FALLBACK, inr } from "@/lib/plans";
import api from "@/lib/api";

export default function PricingPage() {
  const navigate = useNavigate();
  const [plans, setPlans] = useState(FALLBACK);
  useEffect(() => { api.get("/public/plans").then((r) => setPlans(r.data.plans)).catch(() => {}); }, []);

  return (
    <div className="bg-cream min-h-screen mandala">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-36 pb-28">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs uppercase tracking-[0.3em] text-maroon mb-4">Pricing</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-ink font-medium">Plans that grow with your studio</h1>
          <p className="text-ink/60 mt-5">Simple, transparent pricing in Indian Rupees.</p>
        </div>
        <div className="grid lg:grid-cols-3 gap-6 mt-16 items-stretch">
          {plans.map((p) => (
            <div key={p.id} className={`relative h-full rounded-2xl p-8 flex flex-col ${p.popular ? "border-2 border-gold bg-gradient-to-b from-marigold/10 to-white shadow-xl shadow-gold/20" : "bg-white border border-maroon/10"}`}>
              {p.popular && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-maroon text-cream text-xs font-medium px-4 py-1 rounded-full">Most Popular</div>}
              <div className="text-ink font-medium text-lg">{p.name}</div>
              <div className="text-sm text-ink/55 mt-1">{p.tagline}</div>
              <div className="mt-6 flex items-end gap-1"><span className="font-serif text-5xl text-maroon">{inr(p.price)}</span><span className="text-ink/50 mb-1.5">/{p.period === "month" ? "mo" : p.period}</span></div>
              <ul className="mt-7 space-y-3 flex-1">
                {p.features.map((f) => <li key={f} className="flex items-start gap-2.5 text-sm text-ink/70"><Check className="w-4 h-4 text-gold mt-0.5 shrink-0" />{f}</li>)}
              </ul>
              <button data-testid={`pricing-page-${p.id}`} onClick={() => navigate("/register")}
                className={`mt-8 w-full rounded-full py-3 font-medium transition-colors ${p.popular ? "bg-maroon text-cream hover:bg-maroon-dark" : "bg-white text-ink border border-maroon/15 hover:border-gold"}`}>
                Start with {p.name}
              </button>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
